import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "@/components/icon/Icon";
import { ArrowLeft, ArrowRight, Sizes } from "@/components/icon/IconList";
import { useCarousel } from "@/components/Home/hooks/useCarousel";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { Typography } from "@bookips/sds";
import Image from "next/image";
/**
 * 카테고리 배너 컴포넌트
 * embla-carousel을 사용하여 여러 이미지를 슬라이드 형태로 표시
 */ export const CategoryBanner = (param)=>{
    let { banners , images , className , pageType ="edition"  } = param;
    const { isMobile , isTablet  } = useWindowDimensions();
    const { emblaRef , currentIndex , scrollPrev , scrollNext  } = useCarousel({
        options: {
            loop: true,
            dragFree: false
        }
    });
    var _images_map;
    // 하위 호환성: images가 전달된 경우 banners 형식으로 변환
    const bannerItems = banners || ((_images_map = images === null || images === void 0 ? void 0 : images.map((url, index)=>({
            id: index,
            imageUrl: url
        }))) !== null && _images_map !== void 0 ? _images_map : []);
    if (!bannerItems.length) return null;
    // 페이지 타입별 Position 값
    const position = pageType === "system" ? "System Category" : "Edition Category";
    // MX-354/MX-365: 배너 클릭 핸들러
    const handleBannerClick = (banner)=>{
        mixpanelEvent("AD Banner Clicked", {
            "Button URL": banner.link || "",
            ID: banner.id,
            Position: position
        });
        if (banner.link) {
            const appEndpoint = process.env.NEXT_PUBLIC_APP_ENDPOINT || "https://solvook.com";
            const isInternalLink = banner.link.includes(appEndpoint);
            if (isInternalLink) {
                window.location.href = banner.link;
            } else {
                window.open(banner.link, "_blank");
            }
        }
    };
    // MX-353: 인디케이터 버튼 클릭 핸들러
    const handleIndicatorClick = (direction)=>{
        mixpanelEvent("Banner Indicator Clicked");
        if (direction === "prev") {
            scrollPrev();
        } else {
            scrollNext();
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("relative w-full aspect-[4/1] md:aspect-[912/140] bg-white rounded-md overflow-hidden", className),
        children: [
            /*#__PURE__*/ _jsx("div", {
                ref: emblaRef,
                className: "overflow-hidden h-full",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex h-full",
                    children: bannerItems.map((banner, index)=>/*#__PURE__*/ _jsx("div", {
                            className: "flex-[0_0_100%] min-w-0 relative cursor-pointer",
                            onClick: ()=>handleBannerClick(banner),
                            role: "link",
                            tabIndex: 0,
                            onKeyDown: (e)=>{
                                if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    handleBannerClick(banner);
                                }
                            },
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: isMobile ? banner.imageUrlMobile || banner.imageUrl : isTablet ? banner.imageUrlTablet || banner.imageUrl : banner.imageUrlPc || banner.imageUrl,
                                alt: "배너 ".concat(index + 1),
                                fill: true,
                                className: "object-cover",
                                priority: index === 0
                            })
                        }, banner.id))
                })
            }),
            bannerItems.length > 1 && /*#__PURE__*/ _jsxs("div", {
                className: "hidden sm:flex absolute bottom-3 right-4 items-center gap-0 bg-gray-900/50 rounded-full overflow-hidden",
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: ()=>handleIndicatorClick("prev"),
                        className: "hidden md:flex items-center justify-center h-full pl-1.5 pr-0 py-0.5",
                        "aria-label": "이전 배너",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: ArrowLeft,
                            size: Sizes.small,
                            color: "white"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-center min-w-[32px] px-2 md:px-0 py-0.5 gap-0.5",
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "text-white text-center whitespace-nowrap",
                                children: currentIndex + 1
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "text-white",
                                children: "/"
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "subtitle2",
                                className: "text-white text-center whitespace-nowrap",
                                children: bannerItems.length
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: ()=>handleIndicatorClick("next"),
                        className: "hidden md:flex items-center justify-center h-full pl-0 pr-1.5 py-0.5",
                        "aria-label": "다음 배너",
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: ArrowRight,
                            size: Sizes.small,
                            color: "white"
                        })
                    })
                ]
            })
        ]
    });
};
